/**
 * ## cortex:std:ApplicationError
 * Custom error type to throw when application flow fails.
 */
export class ApplicationError extends Error {
    constructor(message) {
        super(message);
        this.message = message;
        this.name = 'ApplicationError';
        Object.setPrototypeOf(this, ApplicationError.prototype);
    }
}
